var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBurgerPartial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.0048C22 11.4553 21.5547 11.0098 21.0052 11.0095L3.00025 11.0005C2.44791 11.0002 2 11.4479 2 12.0002C2 12.5524 2.4476 13 2.99975 13H21.0048C21.5544 13 22 12.5544 22 12.0048ZM2 18C2 17.4477 2.44772 17 3 17H14.3333C14.8856 17 15.3333 17.4477 15.3333 18C15.3333 18.5523 14.8856 19 14.3333 19H3C2.44771 19 2 18.5523 2 18ZM22 6.00025C22 5.44783 21.5522 5 20.9998 5H3.00475C2.44984 5 2 5.44984 2 6.00475C2 6.55985 2.45015 7.00978 3.00525 7.0095L21.0002 7.0005C21.5525 7.00022 22 6.55248 22 6.00025Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBurgerPartial);
export default __webpack_public_path__ + "static/media/icn_burger_partial.056617880b412abb62c1501d351ae180.svg";
export { ForwardRef as ReactComponent };